export default {

    getDebtsTribanco: {
        url: 'tribanco/debts',
        method: 'post',
    },
    getInvoicesTribanco: {
        url: 'tribanco/invoices',
        method: 'get',
    },
    viewAgreementsTribanco: {
        url: 'tribanco/viewAgreements',
        method: 'post',
    },

    getInstallmentsTribanco: {
        url: 'tribanco/getInstallments',
        method: 'post',
    },
    
    getOffersTribanco: {
        url: 'tribanco/getOffers',
        method: 'post',
    },
    
    getAgreementTribanco: {
        url: 'tribanco/agreement',
        method: 'post',
    },
    
    sendSmsOrEmail: { 
        url: 'sendOffer', 
        method: 'post', 
    },

    downloadBoleto: { 
        url: 'tribanco/boleto', 
        method: 'post', 
    },
    logDownloadBoleto: {
        url: 'tribanco/logDownloadBoleto',
        method: 'post',
    },
    logCopyDigitableLine: {
        url: 'tribanco/logCopyDigitableLine',
        method: 'post',
    },

    optionsInstallments: { 
        url: 'tribanco/parc-options', 
        method: 'post', 
    },

    downloadBoletoSegundaVia: { 
        url: 'tribanco/boleto-segunda-via', 
        method: 'post', 
    },
    sentProposalTricard: {
        url: 'tribanco/insert-proposal',
        method: 'post',
    },
    sentProposalTribanco: {
        url: 'tribanco/send-proposal',
        method: 'post',
    },

}